import React from "react";
import { FiCheckCircle, FiClock } from "react-icons/fi";

import { getNewsStatusMeta } from "../../News/utils/newsAdminUtils";

export default function AdminStatusBadge({ active }) {
  const meta = getNewsStatusMeta(active);
  const Icon = active ? FiCheckCircle : FiClock;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold ${meta.className}`}
    >
      <Icon />
      {meta.label}
    </span>
  );
}